import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 256 256",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M223.68 66.15L135.68 18C133.32 16.71 130.68 16.03 128 16.03C125.32 16.03 122.68 16.71 120.32 18L32.32 66.18C29.83 67.55 27.75 69.57 26.31 72.02C24.86 74.47 24.09 77.26 24.08 80.1V175.9C24.09 178.74 24.86 181.53 26.31 183.98C27.75 186.43 29.83 188.45 32.32 189.82L120.32 238C122.68 239.29 125.32 239.97 128 239.97C130.68 239.97 133.32 239.29 135.68 238L223.68 189.82C226.17 188.45 228.25 186.43 229.69 183.98C231.14 181.53 231.91 178.74 231.92 175.9V80.1C231.91 77.26 231.14 74.47 229.69 72.02C228.25 69.57 226.17 67.55 223.68 66.18ZM128 32L207.06 75.27L128 118.54L48.94 75.27L128 32ZM40 89.32L120 132.7V218.32L40 174.49V89.32ZM216 174.46L136 218.32V132.73L216 89.32V174.46Z",
		fill: "currentColor"
	})
});
export default SvgCube;
